import { CHATBOT_ID } from '../../constants/constants'

/**
 * Currently we open web chatbot on both web and webviews. Once a bridge
 * for webview-native apps is developed, we will need to transition to
 * opening the native chatbot specifically for webviews.
 */
export const openChatbot = () => {
	if (typeof document !== 'undefined') {
		document.getElementById(CHATBOT_ID)?.click()
	}
}
